/* common.js */

$(document).ready(function()
{
    // top menu switcher
    $('.navbar-burger').click(function() {
        $(this).toggleClass('is-active');
        $('#primary-menu').toggleClass('is-active');
        $('html').toggleClass('is-clipped');
    });

    // top menu hide
    $('.header__menu-overlay, .header__menu-link-anchor').click(function() {
        $('.navbar-burger').removeClass('is-active');
        $('#primary-menu').removeClass('is-active');
        $('html').removeClass('is-clipped');
    });

});
